export default __webpack_public_path__ + "static/media/srch-on-blue.d5e49ef5.svg";